"use client";

import { memo } from "react";
import { ListingList } from "./listing-list";
import { MarketplaceFilterControlsPopover } from "./marketplace-filter-controls-popover";
import type { MarketplaceJob } from "./use-cluster";

type ListingsPanelProps = {
  jobs: MarketplaceJob[];
  loading: boolean;
  /** Geolocation for the relocated AI "near me" filter input. */
  userLatitude?: number;
  userLongitude?: number;
  /** Phase 5 wiring. */
  selectedId?: string | null;
  hoveredId?: string | null;
  onSelect?: (job: MarketplaceJob) => void;
  onHover?: (id: string | null) => void;
  /** Phase 6: desktop collapse toggle. */
  collapsed?: boolean;
  onToggleCollapse?: () => void;
};

function ListingsPanelInner({
  jobs,
  loading,
  userLatitude,
  userLongitude,
  selectedId,
  hoveredId,
  onSelect,
  onHover,
}: ListingsPanelProps) {
  return (
    <div className="flex h-full min-h-0 flex-col border-border border-r bg-background">
      <div className="flex shrink-0 items-center gap-3 border-border border-b px-3 py-2.5">
        <div className="min-w-0">
          <p className="truncate font-medium text-foreground text-sm leading-5">
            {jobs.length.toLocaleString()} {jobs.length === 1 ? "job" : "jobs"}
          </p>
          <p className="truncate text-muted-foreground text-xs leading-4">
            Visible on the map
          </p>
        </div>
        <div className="ml-auto shrink-0">
          <MarketplaceFilterControlsPopover
            userLatitude={userLatitude}
            userLongitude={userLongitude}
          />
        </div>
      </div>
      <ListingList
        hoveredId={hoveredId}
        jobs={jobs}
        loading={loading}
        onHover={onHover}
        onSelect={onSelect}
        selectedId={selectedId}
        userLatitude={userLatitude}
        userLongitude={userLongitude}
      />
    </div>
  );
}

export const ListingsPanel = memo(ListingsPanelInner);
